import { QueryPart, QueryPartsToStructuredQuery, StructuredQuery } from '@stylehaven/components';
import { DottedKey } from '../entities/metadata-field.entity';
import { LuceneParser } from '../../helpers/lucene-parser.helper';

/** Every base query carries this clause; a saved/loaded query must not remove it from search results. */
function isNotBaseQueryPart(queryPart: QueryPart): boolean {
    return !(
        queryPart.field === DottedKey.RecordType &&
        (queryPart.values.includes('DepotRequest') || queryPart.values.includes('(DepotRequest)'))
    );
}

/**
 * Turns a saved query's raw Lucene string into the structured query the URL/facets understand. Shared
 * between the search bar's own "load" flow and any other place that loads a saved query (HFBD-4 saved
 * views panel's sibling saved-queries section), so both stay in sync with a single transformation.
 */
export function savedQueryToStructuredQuery(luceneParser: LuceneParser, query: string): StructuredQuery {
    // Temp fix for negative queries: '*:*' (match everything) is not valid input for the parser below.
    const queryParts: QueryPart[] = luceneParser.luceneQueryToQueryParts(query.replace('*:*', ''));

    return QueryPartsToStructuredQuery(queryParts.filter(isNotBaseQueryPart));
}
